require.register("ffss/ui/modal/Alert", function(exports, require, module){
  $0
  
});

